/**
 * Created by intellicar-sunny on 4/07/20.
 */
import * as d3 from "d3";
import React, { Component } from "react";
import "./EVReport.css";
import { orderBy } from "lodash";
import moment from "moment";
import { connect } from "react-redux";
import EVInsight from "./EVInsight/EVInsight";
import ReportAPIs from "../../../../APIs/ReportAPIs";
import EVTrip from "./EVTrip/index";
import InDatePicker from "../../schema/InDatePicker/InDatePicker";

const colorArray = [
  "#6a9e6d",
  "#c78752",
  "#3c80ce",
  "#e0d975",
  "#cd7391",
  "#9f3fc5",
  "	#ffa600",
  "#0a5477",
  "#bd71ef",
  "#0fc111",
  "#966868",
  "#50b6bb",
];
class EVReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 1,
      currentDate: moment().startOf("day").valueOf(),
      fetchedAt: moment().valueOf(),
      isLoading: false,
      intervalId: null,
    };
    this.fetchEVDate = this.fetchEVDate.bind(this);
    this.handleRealtime = this.handleRealtime.bind(this);
    this.goLive = this.goLive.bind(this);

    // document.getElementsByClassName("rw-container")[0].style.top = "53px";
  }

  // componentDidMount() {
  //   document.getElementsByClassName("rw-toolbar")[0].style.display = "none";
  //   document.getElementsByClassName("rw-container")[0].style.top = "53px";
  //   document
  //     .getElementById("evInsight")
  //     .addEventListener("click", function (event) {
  //       console.log("click event:", event.target.parentElement);
  //       if (event.target.id === "evContainer") {
  //         if (this.state.isExpanded) {
  //           this.setState({ isExpanded: false, expandedWidget: null });
  //         }
  //       }
  //     });
  // }
  // componentWillUnmount() {
  //   document.getElementsByClassName("rw-container")[0].style.top = "95px";

  //   document.getElementsByClassName("rw-toolbar")[0].style.display = "flex";
  // }

  getTableData(data) {
    let distance = [];
    for (const [key, value] of Object.entries(data)) {
      distance.push(value);
    }

    return distance;
  }

  processData(dataObj) {
    let bars = [];
    var parseTime = d3.timeParse("%H");

    let data = Object.entries(dataObj);
    for (let idx in data) {
      bars.push({
        hours: parseTime(data[idx][0]),
        time: data[idx][1]["time"],
        count: data[idx][1]["count"],
        vehicles: data[idx][1]["vehiclelist"],
      });
    }
    return bars;
  }

  processDashboardData(data) {
    let keys = Object.entries(data);
    for (let idx in keys) {
      if (
        keys[idx][0] === "meta" ||
        keys[idx][0] === "chargedistribution" ||
        keys[idx][0] === "vehiclefullycharged"
      ) {
        continue;
      }
      if (keys[idx][0] === "batterytemp") {
        keys[idx][1].history = orderBy(
          keys[idx][1].history,
          ["battery_temp"],
          ["desc"]
        );
        keys[idx][1].history = keys[idx][1].history.sort(function (a, b) {
          return (a["battery_temp"] === null) - (b["battery_temp"] === null);
        });
      } else if (keys[idx][0] === "todaydistance") {
        let distanceData = keys[idx][1].history;
        data["todaydistance"].history = orderBy(
          distanceData,
          ["soc"],
          ["desc"]
        );

        data["todaydistance"].history = data["todaydistance"].history.sort(
          function (a, b) {
            return (a["soc"] === null) - (b["soc"] === null);
          }
        );
      } else if (keys[idx][0] === "todaycharging") {
        let historyData = this.processData(keys[idx][1]);
        data["todaycharging"] = historyData;
      } else {
        keys[idx][1].history = orderBy(keys[idx][1].history, ["soc"], ["desc"]);
        keys[idx][1].history = keys[idx][1].history.sort(function (a, b) {
          return (a["soc"] === null) - (b["soc"] === null);
        });
      }
    }

    this.props.dispatch({
      type: "SAVE_EV_DASHBOARD_DATA",
      data: data,
    });

    this.setState({ isLoading: false });
  }
  loadRealtime() {
    this.setState({ isLoading: true });

    const auth = window.getAuth();
    let payload = {
      groupid: window.userGroups[0].groupid,
      token: auth.token,
      starttime: moment().startOf("day").unix() * 1000,
    };
    ReportAPIs.getEVDashboard(payload)
      .then((rsp) => {
        this.setState({ fetchedAt: moment().valueOf() });
        this.processDashboardData(rsp);
      })
      .catch(() => {});
  }

  componentWillMount() {
    if (!this.props.evDashboard) {
      if (
        moment().format("DD-MM") ==
        moment(this.state.currentDate).format("DD-MM")
      ) {
        this.loadRealtime();

        let intervalId = setInterval(() => {
          this.loadRealtime();
        }, 600000);
        this.setState({ intervalId: intervalId });
      } else {
        clearInterval(this.state.intervalId);
        this.loadEVDashboard(moment().unix() * 1000);
      }
    }
  }

  loadEVDashboard() {
    this.setState({ isLoading: true });
    const auth = window.getAuth();
    let payload = {
      groupid: window.userGroups[0].groupid,
      token: auth.token,
      starttime: this.state.currentDate,
    };
    ReportAPIs.getEVDashboard(payload)
      .then((rsp) => {
        this.setState({ fetchedAt: this.state.currentDate });

        this.processDashboardData(rsp);
      })
      .catch(() => {});
  }

  fetchEVDate(date, dateValue) {
    let data = date.format("MM-DD-YYYY");
    this.setState({
      currentDate: moment(dateValue).startOf("day").unix() * 1000,
    });
  }
  handleRealtime() {
    if (
      moment().format("DD-MM") == moment(this.state.currentDate).format("DD-MM")
    ) {
      this.loadRealtime();

      let intervalId = setInterval(() => {
        this.loadRealtime();
      }, 600000);
      this.setState({ intervalId: intervalId });
    } else {
      clearInterval(this.state.intervalId);
      this.loadEVDashboard();
    }
  }

  goLive() {
    this.setState(
      { currentDate: moment().startOf("day").unix() * 1000 },
      () => {}
    );
  }

  render() {
    return (
      <div className="EVReport">
        <div className="reportContainer">
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* {this.props.evReportTab === 1 ? (
              <EVInsight
                isLoading={this.state.isLoading}
                evDashboard={this.props.evDashboard}
                isLive={moment().format("DD-MM") ===moment(this.state.fetchedAt).format("DD-MM")}
              />
            ) : (
              <EVTrip />
            )} */}

            <div
              className="Message"
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {/* <div style={{ fontSize: 16, fontWeight: 400, color: "gray" }}>
                We have seperated our EV Analytics from TRACK for a holistic
                insights for our EV Customers.
              </div> */}
              <div
                onClick={() => {
                  window.open("https://surge.intellicar.in/ ", "_blank");
                }}
                style={{
                  cursor: "pointer",
                  fontWeight: 500,
                  marginTop: "1rem",
                  width: "10rem",
                  height: "3rem",
                  background: "#2ecc71",
                  borderRadius: 4,
                  fontSize: 12,
                  padding: 6,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  textAlign: "center",
                }}
              >
                Go to Surge
              </div>
            </div>
          </div>
        </div>
      </div>
      // <div>
      //   HIii
      // </div>
    );
  }
}

const mapPropsToState = (state) => {
  return {
    evDashboard: state.evDashboard,
    evReportTab: state.evReportTab,
  };
};

export default connect(mapPropsToState)(EVReport);
